<template>
  <mdb-modal
    ref="mdbModal"
    centered
    elegant
    scrollable
    size="lg"
    :show="showModal"
    @close="$emit('close', false);isLoading=true"
  >
    <mdb-modal-header>
      <mdb-modal-title>
        Agenda una cita
      </mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body
      class="p-0 overflow-auto"
    >
      <p
        v-if="isLoading"
        class="text-center text-uppercase user-select-none"
      >
        <font-awesome-icon
          icon="circle-notch"
          size="lg"
          class="d-inline-block fa-spin"
        />
        Cargando agenda...
      </p>
      <iframe
        :src="`${httpEndpoint}#${doctor.profileUrl
          ? doctor.profileUrl : '|'+doctor.id}`"
        frameborder="0"
        scrolling="auto"
        class="col-12 iframe-responsive"
        @load="loaded();"
      />
    </mdb-modal-body>
  </mdb-modal>
</template>

<script>
import {mdbModal, mdbModalHeader, mdbModalTitle,
  mdbModalBody} from 'mdbvue';
export default {
  name: 'ModalAgendarCita',
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
  },
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    doctor: {
      default() {
        return {
          profileInfo: {
            acceptCallReq: null,
          },
          contactsInfo: [],
          works_at: [],
        };
      },
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      httpEndpoint: process.env.NODE_ENV === 'production'
        ? process.env.VUE_APP_RESERVA_HTTPS
        : 'http://localhost:8081',
      isLoading: true,
    };
  },
  computed: {
  },
  watch: {
  },
  methods: {
    loaded() {
      console.log('Cargó');
      this.isLoading = false;
    },
  },
};
</script>

<style lang="scss">
.iframe-responsive {
  display: block;
  padding: 0;
  height: calc(100vh - 6rem);
  max-height: 80vh;
  margin: auto;
  width: 100% !important;

  @media (min-width: 576px) {
    width: 100% !important;
    height: 75vh;
    max-height: 75vh;
  }
}
</style>
